export default __webpack_public_path__ + "static/media/Nuleep-Logo.5aa82c74.svg";